/**
 * Web stub for react-native-device-info
 * Provides compatibility layer for web platform
 */

export const DeviceInfo = {
  getVersion: () => '1.0.0',
  getBuildNumber: () => '1',
  getApplicationName: () => 'Pyxi',
  getUniqueId: () => Promise.resolve('web-device-' + Math.random().toString(36).substr(2, 9)),
  getDeviceId: () => 'web-device',
  getSystemVersion: () => '',
  getSystemName: () => 'Web',
  getModel: () => 'Web Browser',
  getManufacturer: () => 'Browser',
  isTablet: () => false,
  hasGms: () => Promise.resolve(false),
  hasHms: () => Promise.resolve(false),
  getReadableVersion: () => '1.0.0-1',
  getBrand: () => 'Web',
  getBaseOS: () => 'Web',
  getAPILevel: () => Promise.resolve(0),
  getCarrier: () => Promise.resolve(''),
  isEmulator: () => Promise.resolve(false),
  isTabletMode: () => Promise.resolve(false),
  getBootloader: () => Promise.resolve(''),
  getDevice: () => '',
  getDisplay: () => '',
  getFingerprint: () => '',
  getHardware: () => '',
  getHost: () => '',
  getProduct: () => '',
  getTags: () => '',
  getType: () => '',
  getSecurityPatch: () => '',
  getIsHeadless: () => false,
  getBundle: () => '',
  getInstallerPackageName: () => Promise.resolve(''),
  getPhoneNumber: () => Promise.resolve(''),
  getAndroidId: () => Promise.resolve(''),
  getBuildId: () => Promise.resolve(''),
  getDeviceNameSync: () => 'Web Device',
  getDeviceName: () => Promise.resolve('Web Device'),
  getUsedMemory: () => Promise.resolve(0),
  getTotalMemory: () => Promise.resolve(0),
};

export default DeviceInfo;
